<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3233_8195)">
      <path
        d="M12 15V13.5C14.8997 13.5 17.25 11.4853 17.25 9C17.25 6.51469 14.8997 4.5 12 4.5C9.10031 4.5 6.75 6.51469 6.75 9"
        :stroke="color"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 21C12.8284 21 13.5 20.3284 13.5 19.5C13.5 18.6716 12.8284 18 12 18C11.1716 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1716 21 12 21Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_3233_8195">
        <rect width="24" height="24" :fill="color" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "QuestionMark",
  props: {
    width: {
      type: [String, Number],
      default: 24,
    },
    height: {
      type: [String, Number],
      default: 24,
    },
    color: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style></style>
